export default __webpack_public_path__ + "static/media/HOME_rejilla.024df751.svg";